export const spaceName = 'odDishType';

export interface DishTypeSettings {
  editingId: number;

  selectedTab: 'translation' | 'information';
  selectedTranslatedLang: string;

  originalData: {
    originalTranslation: any;
    originalInformation: any;
  };

  currentData: {
    currentTranslation: any;
    currentInformation: any;
  };
}

export default {
  selectedTab: 'information',
  selectedTranslatedLang: 'en_AU',
} as DishTypeSettings;
